import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import reducers from './../reducers';

export const initialState = {
    user: null,
    restaurant: null,
    restaurants: null,
    config: null,
    isSavingConfig: false,
    isSavedConfig: false,
    isLoadingRestaurant: true,
    isSavingRestaurant: false,
    isSavedRestaurant: false,
    errorRestaurant: { state: false, reason: "" },
    error: { state: false, reason: "" },
    nextReservations: null,
    places: null,
    hitos: null,
    cities: null,
    countries: null,
    neighborhoods: null,
    provinces: null,
    styles: null,
    types: null,
    services: null,
    promotions: null,
    isSavingPromotions: false,
    isSavedPromotions: false,
    servicesAdmin: null,
    isSavingServices: false,
    isSavedServices: false,
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(reducers, initialState, composeEnhancers(applyMiddleware(thunk)));